export class NetworkError extends Error {
  constructor() {
    super('Looks like your internet is off. Please check your wifi and try again');
    this.name = 'NetworkError';
  }
}
